import { useQuery } from '@tanstack/react-query';
import { useFeatureFlagApi } from '../api/useFeatureFlagApi';

export const useFeatureFlag = (flagName: string): { enabled: boolean; isLoading: boolean } => {
    const { getFeatureFlags } = useFeatureFlagApi();

    const { data: flags, isLoading } = useQuery({
        queryKey: ['featureFlags'],
        queryFn: getFeatureFlags,
        staleTime: 5 * 60 * 1000,
        cacheTime: 30 * 60 * 1000,
        refetchOnWindowFocus: false,
        initialData: {},
        initialDataUpdatedAt: 0,
    });

    return {
        enabled: flags[flagName] ?? false,
        isLoading,
    };
};
